'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/history/lib/ExecutionEnvironment.js
// module id = 224
// module chunks = 1 4 6